export abstract class PixelMeasurements {
  private readonly centimeterToPixelRatio: number;

  constructor(centimeterToPixelRatio: number) {
    this.centimeterToPixelRatio = centimeterToPixelRatio;
  }

  protected toPixels(centimeters: number) {
    const pixelValue = centimeters * this.centimeterToPixelRatio;
    return `${pixelValue}px`;
  }
}
